export default __webpack_public_path__ + "9f7685df90bdc27a5366212391b253b1.svg";